

export default function OptionsIcon({ className }) {
    return (
        <svg className={className} width="2" height="12" viewBox="0 0 2 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2" height="2" rx="1" fill="#212121" />
            <rect y="5" width="2" height="2" rx="1" fill="#212121" />
            <rect y="10" width="2" height="2" rx="1" fill="#212121" />
        </svg>

    )
}